import { forwardRef } from "react";

import "./Truncate.css";

import type { CSSProperties, ReactNode } from "react";

export interface TruncateProps {
  children?: ReactNode;
  lines?: number;
  title?: string;
}

export const Truncate = forwardRef<HTMLSpanElement, TruncateProps>(
  function Truncate({ children, lines, title }, ref) {
    const customProperties = {
      "--truncate-line-limit": lines,
    } as CSSProperties;

    return (
      <span
        ref={ref}
        className="Truncate"
        style={customProperties}
        title={title}
      >
        {children}
      </span>
    );
  },
);
